import { axiosGetHandler, axiosPostHandler } from '../../config';

export function changeItemLikeState(args, form) {
  let url = '/game/the_finals/change_like';
  return axiosPostHandler(url, args, form);
}

//q, sort_key, sort_direction, offset, limit
// sort_direction = 0 升序， 1降序
export function getPalList(args) {
  let url = '/game/palworld/list_pal_info';
  return axiosGetHandler(url, args);
}

//id
export function getPalDetail(args) {
  let url = '/game/palworld/get_pal_detail';
  return axiosGetHandler(url, args);
}

//同上
export function getItemList(args) {
  let url = '/game/palworld/list_pal_item';
  return axiosGetHandler(url, args);
}

export function getItemDetail(args) {
  let url = '/game/palworld/get_pal_item_detail';
  return axiosGetHandler(url, args);
}
